import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-reciprocal-charge-modal',
  templateUrl: './reciprocal-charge-modal.component.html',
  styleUrls: ['./reciprocal-charge-modal.component.scss'],
})
export class ReciprocalChargeModalComponent implements OnInit {
  @Input() reciprocalVenueOptions: { id: string; name: string }[] = [];

  @Input() initialVenueId = '';

  @Input() initialMemberName = '';

  @Input() initialMemberNumber = '';

  selectedVenueId = '';

  memberName = '';

  memberNumber = '';

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.selectedVenueId = this.initialVenueId || '';
    this.memberName = this.initialMemberName || '';
    this.memberNumber = this.initialMemberNumber || '';
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  confirm() {
    const venueId = this.selectedVenueId?.trim();
    const name = this.memberName?.trim();
    const number = this.memberNumber?.trim();
    if (!venueId || !name || !number) {
      return;
    }
    this.modalCtrl.dismiss({
      reciprocalVenueId: venueId,
      reciprocalMemberName: name,
      reciprocalMemberNumber: number,
    });
  }
}
